import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "../../components/loading-container";
import { WebLayout } from "../components/web-layout";
import { PasswordResetView } from "./password-reset-view";

import { API } from "../../utils/AxiosInstance";
import { useBranding } from "../../contexts/branding";

function TokenError() {
    const { label } = useBranding();
    const { t } = useTranslation();
    return (
        <div>
            <p>
                {t("password_exp1")}{" "}
                <NavLink
                    to="/forgot-password"
                    className={label !== "HabitNu" ? "ada-link" : ""}
                >
                    {t("Forgot password")}
                </NavLink>{" "}
                {t("password_exp2")}.
            </p>
        </div>
    );
}

export function PasswordReset() {
    const { token } = useParams<{ token: string }>();
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);

    useEffect(() => {
        async function fetchUrl() {
            try {
                setLoading(true);
                await API.get(`/password_resets/${token}/edit`);
                setLoading(false);
            } catch {
                setLoading(false);
                setError(true);
            }
        }

        void fetchUrl();
    }, [token]);

    return (
        <WebLayout>
            {isLoading && <LoadingContainer />}

            {isError && <TokenError />}

            {!isLoading && !isError && <PasswordResetView token={token!} />}
        </WebLayout>
    );
}
